import axios from "axios"; // 引用axios
import { ElMessage } from "element-plus";
import config from "./config";

// 初始化，获取当前环境的接口链接
const instance = axios.create({
  baseURL: config.baseUrl[config.mode],
  timeout: 60000,
});

/**
 * 设置响应拦截器
 * 如果返回值为401，登录超时
 * 自动重新登录
 */
instance.interceptors.response.use(
  response => {
    return response;
  }, error => {
    switch(error.response.status) {
      case 401:
        // 缓存登录超时页面链接，用于登录成功后的跳转。排除路由login_auto
        // if (window.location.href.indexOf('login_auto') < 0) {
        //   ElMessage.error('登录超时');
        //   localStorage.setItem('overtime_url', window.location.href);
        //   location.replace('/h5/index.html');
        // }
        break;
      default:
        ElMessage.error({
          showClose: true,
          message: '网络异常，请稍后再试，错误代码：' + error.response.status,
        });
        break;
    }
    return Promise.reject(error);
  });

/**
 * get请求
 * @param {String} url 
 * @param {Object} params 
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post请求
 * @param {String} url 
 * @param {Object} data 
 */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
/**
 * 文件上传
 * @param {String} url 
 * @param {Array|Object} data 
 */
export function file(url, data) {
  return new Promise((resolve, reject) => {
    var forms = new FormData()
    if (data instanceof Array) {
      for (let i in data) {
        forms.append('file', data[i]);
      }
    } else {
      forms.append('file', data);
    }
    instance
      .post(url, forms, {
        headers:{'Content-Type': 'multipart/form-data'}
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}